module.exports = QC;